module.exports = __webpack_public_path__ + "img/success-circle-phone-icon.965484f0.svg";